import ErrorP from "../componentes/compartidos/ErrorP.js";

function ErrorPagina() {
    return (
      <>
      <ErrorP></ErrorP>
      </>
    );
  };
  
  export default ErrorPagina;
  